// extracted by mini-css-extract-plugin
var _1 = "Comment-module__animatedBackground--rZsY4";
var _2 = "Comment-module__comment--KEQRz";
var _3 = "Comment-module__commentContent--qMUFO";
var _4 = "4px";
var _5 = "Comment-module__editing--Obr9W";
var _6 = "Comment-module__editingActions--hdkA4";
var _7 = "Comment-module__first--J8ywp";
var _8 = "Comment-module__firstFolded--F_sbl";
var _9 = "Comment-module__last--hpU_m";
var _a = "Comment-module__lastFolded--ApeI3";
var _b = "Comment-module__left--mjoEo";
var _c = "Comment-module__lineBottom--k69lB";
var _d = "Comment-module__lineTop--Mz6tu";
export { _1 as "animatedBackground", _2 as "comment", _3 as "commentContent", _4 as "commentMetaMarginBottom", _5 as "editing", _6 as "editingActions", _7 as "first", _8 as "firstFolded", _9 as "last", _a as "lastFolded", _b as "left", _c as "lineBottom", _d as "lineTop" }
